import numeral from 'numeral';

const keys = (t) => [
    {
        key: 'sumClicks',
        label: t('discover.appearances.chart.sumClicks'),
        format: '0.00%',
    },
    {
        label: t('discover.appearances.chart.sumImpressions'),
        key: 'sumImpressions',
    },
    {
        label: t('discover.appearances.chart.avgCTR'),
        key: 'avgCTR',
        render: (data) => numeral(data * 100).format('0.00'),
        yAxisID: 'y1',
    },
];

export default keys;
